import { toOverallIndianCurrency } from "../../../MethodMaster/JSXComponentMothod";
import "../DashboardUnique.css";

export default function SummaryCards({ voters, amount, labharti, labharthiLabh }) {
  const formattedAmount = toOverallIndianCurrency(amount);
  const formattedAmontNumber = formattedAmount.formatted;
  const amountInWord = formattedAmount.answer.words;
  return (
    <>
      <div className={"govdash-summaryGrid"}>
        <div className={`${"govdash-summaryCard"} ${"govdash-votersCard"}`}>
          <div className={"govdash-cardContent"}>
            <i className="fas fa-users"></i>
            <div>
              <p className={"govdash-cardLabel"}>Total Voters</p>
              <span className={"govdash-cardValue"}>{voters.toLocaleString()}</span>
            </div>
          </div>
          <div className={"govdash-cardBg"}></div>
        </div>
        <div className={`${"govdash-summaryCard"} ${"govdash-amountCard"}`}>
          <div className={"govdash-cardContent"}>
            <i className="fas fa-money-bill-wave"></i>
            <div>
              <p className={"govdash-cardLabel"}>Total Amount Disbursed</p>
              {/* <span className={"govdash-cardValue"}>₹{amount?.toLocaleString()}</span> */}
              <span className={"govdash-cardValue"}>{formattedAmontNumber}</span>
              <span className={"govdash-wordValue"}>({amountInWord})</span>
            </div>
          </div>
          <div className={"govdash-cardBg"}></div>
        </div>
        {/* <div className={`${"govdash-summaryCard"} ${"govdash-labhartiCard"}`}>
          <div className={"govdash-cardContent"}>
            <i className="fas fa-hand-holding-heart"></i>
            <div>
              <p className={"govdash-cardLabel"}>Total Labharthi</p>
              <span className={"govdash-cardValue"}>{labharti?.toLocaleString()}</span>
            </div>
          </div>
          <div className={"govdash-cardBg"}></div>
        </div> */}
        <div className={`${"govdash-summaryCard"} ${"govdash-labhartiLabhCard"}`}>
          <div className="govdash-cardContent">
            <i className="fas fa-wallet"></i>
            <div>
              <p className="govdash-cardLabel">Total Labharthi Labh</p>
              <span className="govdash-cardValue">{labharthiLabh?.toLocaleString()}</span>
            </div>
          </div>
          <div className="govdash-cardBg"></div>
        </div>
      </div>
      {/* <div className={"govdash-summaryGrid"}>
        <div className={`${"govdash-summaryCard"} ${"govdash-labhartiCard"}`}>
          <div className={"govdash-cardContent"}>
            <i className="fas fa-hand-holding-heart"></i>
            <div>
              <p className={"govdash-cardLabel"}>Total Labharthi</p>
              <span className={"govdash-cardValue"}>{labharti?.toLocaleString()}</span>
            </div>
          </div>
          <div className={"govdash-cardBg"}></div>
        </div>
        <div className={`${"govdash-summaryCard"} ${"govdash-labhartiLabhCard"}`}>
          <div className="govdash-cardContent">
            <i className="fas fa-wallet"></i>
            <div>
              <p className="govdash-cardLabel">Total Labharthi Labh</p>
              <span className="govdash-cardValue">{labharthiLabh?.toLocaleString()}</span>
            </div>
          </div>
          <div className="govdash-cardBg"></div>
        </div>
      </div> */}
    </>
  );
}
